import {CrmSalesforceMetadataModel} from '../../../../models/api/crmSalesforceMetadataModel';
import {CrmSyncAccountDefaultFieldIdsEnum} from '../../../../models/api/crmSyncModel';
import {CrmToFrontCustomFieldMapping} from '../common/crmSyncHelpers';

/*
 * Constants.
 */

export const SalesforceMaxAllAccounts = 150000;
export const salesforceHelpCenterArticle = 'https://help.front.com/t/83hbpb1';

export enum SalesforceAccountTypesEnum {
  ALL = 'all',
  LIST = 'list',
}

export enum SalesforceDefaultCustomFieldIdsEnum {
  NAME = 'Name',
  DOMAINS = 'Website',
  DESCRIPTION = 'Description',
}

export const SalesforceRequiredDefaultFields: ReadonlyArray<CrmToFrontCustomFieldMapping> = [
  {
    crmFieldId: SalesforceDefaultCustomFieldIdsEnum.NAME,
    customFieldId: CrmSyncAccountDefaultFieldIdsEnum.NAME,
  },
];

export const SalesforceOptionalDefaultFields: ReadonlyArray<CrmToFrontCustomFieldMapping> = [
  {
    crmFieldId: SalesforceDefaultCustomFieldIdsEnum.DOMAINS,
    customFieldId: CrmSyncAccountDefaultFieldIdsEnum.DOMAINS,
  },
  {
    crmFieldId: SalesforceDefaultCustomFieldIdsEnum.DESCRIPTION,
    customFieldId: CrmSyncAccountDefaultFieldIdsEnum.DESCRIPTION,
  },
];

/*
 * Types.
 */

export interface SalesforceAccountType {
  type: SalesforceAccountTypesEnum;
  listId?: string | number;
  totalAccounts?: number;
}

/*
 * Helpers.
 */

export function isMaxSalesforceAllAccountsReached(metadata?: CrmSalesforceMetadataModel) {
  if (!metadata) {
    return false;
  }
  return metadata.allAccountsCount >= SalesforceMaxAllAccounts;
}
